import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import { useTranslation } from "react-i18next";
import { Loading } from "app/components/Wrappers";
import Navbar from "app/components/Navbar";
import SessionForm from "../SessionForm";
import SelectedParticipantChip from "../SelectedParticipantChip";
import useBookSessionData from "../hooks/useBookSessionData";
import styles from "./styles.module.scss";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { useHistory } from "react-router-dom";
import { BookSessionState } from "app/reducers/scheduling/bookSession";
import TimezoneInfo from 'app/components/TimezoneInfo';

/* import { useTranslation } from 'react-i18next'; */

const NewSession = () => {
  const history = useHistory();
  const userID = useSelector((state: RootState) => state.user.self.id);
  const bookLessonState = useSelector((state: RootState) => state.bookSession);
  const { t } = useTranslation();

  /**
   * Figma #31: "Back button on this page goes to the Facility Booking Page,
   * defaults to 'By Coach'".
   *
   * A push rather than `goBack()`, because the coach calendar is also reached from
   * Home for a single coach, and #31 wants the facility page either way. The path
   * carries no `tab` parameter, and `FacilityBooking` opens on By Coach without one.
   *
   * In-app only, and no public branch: `/public/availability` is served by
   * `routes/PublicCalendar/NewSession`, not this component, and that page has no
   * back arrow — the browser's own back button is the way out of it.
   */
  const facilityBookingPath = "/sessions/session_availability";

  const { coach } = useSelector(
    (state: RootState): BookSessionState => state.bookSession,
  );

  const fetcher = useCallback(() => {
    if (!userID) {
      return Promise.resolve([]);
    }
    const facilitiesPromise = schedulingFetchGet("/facilities");
    const coachPromise = schedulingFetchGet("/coach_profiles");

    return Promise.all([facilitiesPromise, coachPromise]);
  }, [userID]);

  const [loadingBookLessonData, bookLessonData] = useBookSessionData(fetcher);


  if (loadingBookLessonData || !bookLessonState.facility) {
    return <Loading isLoading loadType="spinner" />;
  }

  return (
    <div className={`${styles.container} sessions-page-container`}>
      <Navbar
        label={t("Book a Session")}
        hasSearch={false}
        hasNotifications={false}
        onBackClick={() => history.push(facilityBookingPath)}
        className={styles.navbar_wrapper}
      >
        <div className={styles.navbar_right}>
          <SelectedParticipantChip
            participantAthleteId={bookLessonState.participantAthleteId}
          />
          <TimezoneInfo timeZone={coach?.timeZone} />
        </div>
      </Navbar>
      <SessionForm bookLessonData={bookLessonData} />
    </div>
  );
};
export default NewSession;
